import useCountdown from "@hooks/useCountdown";
import { useTranslation } from "react-i18next";

/**
 * Dải đếm ngược vắt ngang, nằm ngay dưới mặt bục trong daily-reward-bg.png.
 *
 * intervalMs = 1000 vì design hiển thị cả giây — mặc định của hook là 1 phút và
 * chỉ tự đếm giây ở phút cuối.
 */
const CountdownBar = ({ endsAt }) => {
  const { t } = useTranslation();
  const { days, hours, minutes, seconds } = useCountdown(endsAt, 1000);

  // Còn hơn 24 giờ thì hiển thị DD:HH:MM (bỏ giây); dưới 24 giờ thì HH:MM:SS.
  const parts =
    days >= 1
      ? [
          { value: days, unit: t("daily_reward.days") },
          { value: hours, unit: t("daily_reward.hrs") },
          { value: minutes, unit: t("daily_reward.mins") },
        ]
      : [
          { value: hours, unit: t("daily_reward.hrs") },
          { value: minutes, unit: t("daily_reward.mins") },
          { value: seconds, unit: t("daily_reward.secs") },
        ];

  return (
    <section className="@container relative -mx-4 md:-mx-8">
      {/* Dải đỏ vắt ngang + 2 chỉ vàng viền trên/dưới — cùng bộ style với
          GuessTicker (nền #F2000B/0 → #FF4D11 → #F2000B/0; chỉ vàng #FAECA9 mờ
          hai đầu, dày 3px = h-0.75, blend plus-lighter, canh trong). */}
      <div className="relative flex items-baseline justify-center gap-[1.5cqw] bg-linear-to-r from-[#F2000B]/0 via-[#FF4D11] to-[#F2000B]/0 py-[1.6cqw] text-center before:absolute before:inset-x-0 before:top-0 before:h-0.75 before:bg-linear-to-r before:from-[#FAECA9]/0 before:via-[#FAECA9] before:to-[#FAECA9]/0 before:mix-blend-plus-lighter before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-0.75 after:bg-linear-to-r after:from-[#FAECA9]/0 after:via-[#FAECA9] after:to-[#FAECA9]/0 after:mix-blend-plus-lighter after:content-['']">
        <span className="text-[3.6cqw] font-extrabold text-white [text-shadow:0_0.3cqw_0.4cqw_rgba(160,40,10,0.9)]">
          {t("daily_reward.ends_in")}
        </span>

        {parts.map((part, index) => (
          <span
            key={part.unit}
            className="text-[3.6cqw] font-extrabold text-white [text-shadow:0_0.3cqw_0.4cqw_rgba(160,40,10,0.9)]"
          >
            {/* Số to hơn nhãn đơn vị, đúng như mock */}
            <span className="text-[4.8cqw]">{part.value}</span> {part.unit}
            {index < parts.length - 1 ? " :" : ""}
          </span>
        ))}
      </div>
    </section>
  );
};

export default CountdownBar;
